module.exports = __webpack_public_path__ + "img/00015.8b0a08ed.webp";